import React from 'react';
import { Select, Form } from 'antd';
import transportFieldsConnect from '../../../common/hoc/transportFieldsConnect';
const Option = Select.Option;
const ColorsTypes = ({ form, colorsTypes }) => {
  const { getFieldDecorator } = form;
  return (
    <Form.Item label="Цвет">
      {getFieldDecorator('color_key')(
        <Select
          style={{ width: '100%' }}
          allowClear={true}
          className="ui-select"
          mode="multiple"
          placeholder="Выберите опции"
          dropdownClassName="ui-select__dropdown-multiple"
          showArrow={true}
          maxTagCount={0}
          getPopupContainer={trigger => trigger.parentNode}
        >
          {colorsTypes &&
            colorsTypes.map(type => (
              <Option
                key={type.colorKey}
                value={type.colorKey}
                label={type.colorName}
              >
                {type.colorName}
              </Option>
            ))}
        </Select>
      )}
    </Form.Item>
  );
};

export default transportFieldsConnect(ColorsTypes, ['colorsTypes']);
